import { z } from "zod";

export const userFormSchema = z.object({
  firstName: z
    .string()
    .min(1, "First name is required")
    .optional()
    .or(z.literal("")),
  lastName: z
    .string()
    .min(1, "Last name is required")
    .optional()
    .or(z.literal("")),
  companyId: z
    .string()
    .min(1, "Company is required")
    .optional()
    .or(z.literal("")),
  role: z.string().min(1, "Role is required"),
  phone: z
    .string()
    .regex(
      /^(?:\+?[1-9]\d{7,14}|0\d{10})$/,
      "Phone must be a valid number (e.g. +441234567890, +2349012345678, or 09012345678)"
    )
    .min(10, "Phone must be at least 10 digits")
    .optional()
    .or(z.literal("")),
  personalPhone: z
    .string()
    .regex(
      /^(?:\+?[1-9]\d{7,14}|0\d{10})$/,
      "Phone must be a valid number (e.g. +441234567890, +2349012345678, or 09012345678)"
    )
    .min(10, "Phone must be at least 10 digits")
    .optional()
    .or(z.literal("")),
  officialEmail: z.string().email("Must be a valid email"),
  personalEmail: z
    .string()
    .email("Must be a valid email")
    .optional()
    .or(z.literal("")),
  vessel: z.string().min(1, "Vessel is required").optional().or(z.literal("")),
  vesselCategory: z
    .string()
    .min(1, "Vessel category is required")
    .optional()
    .or(z.literal("")),
  functionalEmail: z
    .string()
    .min(1, "Functional Email is required")
    .optional()
    .or(z.literal("")),
});

export type userFormType = z.infer<typeof userFormSchema>;
